/**
 * authClient — bare Axios instance used exclusively by the auth store.
 * Has NO auth-header injection and NO 401-refresh interceptor so it can
 * safely call /api/auth/token/ without triggering infinite retry loops.
 */
import axios from 'axios'

const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/'

function getCsrfToken() {
  try {
    const match = document.cookie.match(/csrftoken=([^;]+)/)
    return match ? match[1] : ''
  } catch {
    return ''
  }
}

export const authClient = axios.create({
  baseURL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
})

authClient.interceptors.request.use((config) => {
  const csrf = getCsrfToken()
  if (csrf) config.headers['X-CSRFToken'] = csrf
  return config
})

// Transform Axios errors to the legacy shape { status, data } so callers
// can use e.status and e.data the same way as the old fetch-based client.
authClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const err = new Error(`HTTP ${error.response.status}`)
      err.status = error.response.status
      err.data = error.response.data
      return Promise.reject(err)
    }
    return Promise.reject(error)
  },
)
